module.exports = __webpack_public_path__ + "img/1935.8a4374f7.svg";